var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !(_vm.mode == 'view' && !_vm.items.length) ? _c('v-sheet', [_c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 보유 자격증 및 공인 어학성적 ")])]), _c('v-sheet', [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    attrs: {
      "items-per-page": -1,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-filtering": "",
      "mobile-breakpoint": _vm.$vuetify.breakpoint.thresholds.sm
    },
    scopedSlots: _vm._u([{
      key: `item.name`,
      fn: function (_ref) {
        var item = _ref.item,
          value = _ref.value;
        return [_vm.mode == 'form' ? [_c('v-text-field', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.name,
            callback: function ($$v) {
              _vm.$set(item, "name", $$v);
            },
            expression: "item.name"
          }
        }, 'v-text-field', _vm.attrs_input, false))] : [_c('p', {
          staticClass: "page-text grey--text"
        }, [_vm._v(_vm._s(value || "-"))])]];
      }
    }, {
      key: `item.desc`,
      fn: function (_ref2) {
        var item = _ref2.item,
          value = _ref2.value;
        return [_vm.mode == 'form' ? [_c('v-text-field', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.desc,
            callback: function ($$v) {
              _vm.$set(item, "desc", $$v);
            },
            expression: "item.desc"
          }
        }, 'v-text-field', _vm.attrs_input, false))] : [_c('p', {
          staticClass: "page-text grey--text"
        }, [_vm._v(_vm._s(value || "-"))])]];
      }
    }, {
      key: `item.issuer`,
      fn: function (_ref3) {
        var item = _ref3.item,
          value = _ref3.value;
        return [_vm.mode == 'form' ? [_c('v-text-field', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.issuer,
            callback: function ($$v) {
              _vm.$set(item, "issuer", $$v);
            },
            expression: "item.issuer"
          }
        }, 'v-text-field', _vm.attrs_input, false))] : [_c('p', {
          staticClass: "page-text grey--text"
        }, [_vm._v(_vm._s(value || "-"))])]];
      }
    }, {
      key: `item.issuedAt`,
      fn: function (_ref4) {
        var _value$toDate;
        var item = _ref4.item,
          value = _ref4.value;
        return [_vm.mode == 'form' ? [_c('v-date-field', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.issuedAt,
            callback: function ($$v) {
              _vm.$set(item, "issuedAt", $$v);
            },
            expression: "item.issuedAt"
          }
        }, 'v-date-field', _vm.attrs_input, false))] : [_c('p', {
          staticClass: "page-text grey--text"
        }, [_vm._v(_vm._s((value === null || value === void 0 ? void 0 : (_value$toDate = value.toDate) === null || _value$toDate === void 0 ? void 0 : _value$toDate.call(value)) || value || "- "))])]];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-btn', {
          staticClass: "u-pink mx-auto",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('i', {
          staticClass: "icon icon-minus"
        })])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _vm.mode == 'form' ? [_c('v-btn', {
          staticClass: "v-btn--plus rounded-lg",
          attrs: {
            "block": "",
            "color": "grey-f8"
          },
          on: {
            "click": _vm.addItem
          }
        }, [_c('i', {
          staticClass: "icon icon-plus-sm"
        })])] : _vm._e()];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }